import React, { useMemo, useState } from "react";
import Select from "react-select";
import { Row, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { PageHeader } from "CommonComponent";
import { downloadQuarterlyReport } from "../actions/quarterlyReportsActions";
import {
  buildYearOptions,
  currentYearOption,
  toApiQuarter,
} from "../utils/quarterlyReportDownload";
import "./QuarterlyReports.css";

const QUARTER_OPTIONS = [
  { label: "Q1", value: "Q1" },
  { label: "Q2", value: "Q2" },
  { label: "Q3", value: "Q3" },
  { label: "Q4", value: "Q4" },
  { label: "All / Yearly", value: "YEARLY" },
];

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "8px",
    border: "1px solid #DFE4E2",
    boxShadow: "none",
    minHeight: "48px",
    "&:hover": {
      borderColor: "#aaa",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#15162D",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#8A9193",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#fff",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
    color: "#15162D",
  }),
};

const QuarterlyReports = () => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session || {});

  const objectViewedId =
    session.current_object_viewed_id ||
    session.current_page_permissions?.object_id ||
    "";

  const yearOptions = useMemo(() => buildYearOptions(), []);

  const [quarterValue, setQuarterValue] = useState(null);
  const [yearValue, setYearValue] = useState(currentYearOption);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadReport = async () => {
    if (!quarterValue || isDownloading) return;

    const quarter = toApiQuarter(quarterValue.value);
    const year = yearValue?.value || String(new Date().getFullYear());

    setIsDownloading(true);
    try {
      await dispatch(
        downloadQuarterlyReport({
          object_viewed_id: objectViewedId,
          quarter,
          year,
        })
      );
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <PageHeader title="Quarterly Reports" />
      <div className="main-content-div page-card">
        <div className="quarterly-reports-form">
          <Row className="mb-0 align-items-end g-3">
            <Col xs={12} md={6} lg={4}>
              <Form.Label className="label-input">Choose Quarter</Form.Label>
              <Select
                aria-label="Choose Quarter"
                className="multi-select w-100"
                placeholder="Choose Quarter"
                isSearchable={false}
                value={quarterValue}
                styles={customStyles}
                onChange={(newValue) => setQuarterValue(newValue)}
                options={QUARTER_OPTIONS}
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Form.Label className="label-input">Choose Year</Form.Label>
              <Select
                aria-label="Choose Year"
                className="multi-select w-100"
                placeholder="Choose Year"
                isSearchable={false}
                value={yearValue}
                styles={customStyles}
                onChange={(newValue) => setYearValue(newValue)}
                options={yearOptions}
              />
            </Col>
            <Col xs="auto" className="d-flex align-items-end">
              <button
                type="button"
                className="quarterly-reports-download"
                onClick={handleDownloadReport}
                disabled={!quarterValue || isDownloading}
              >
                <img
                  src="/assets/images/download-pdf-icon.svg"
                  alt=""
                  className="quarterly-reports-download-icon"
                  aria-hidden="true"
                />
                {isDownloading ? "Downloading..." : "Download Report"}
              </button>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default QuarterlyReports;
